
export class MynetSearchForm extends React.Component<{}, {}> {
    public render() {
        return (
            <div className="gcse-searchbox-only" ></div>
        )
    }
}